import React from 'react';
import Img from './Img';

export default function Story() {
  return (
    <section id="story" style={{ padding:'84px 0' }}>
      <div style={{ maxWidth:1180, margin:'0 auto', padding:'0 26px', display:'grid', gridTemplateColumns:'0.92fr 1.08fr', gap:56, alignItems:'center' }} className="kt-story-grid">
        <div style={{ position:'relative' }} className="kt-story-art">
          <Img src="/assets/kreme-tops-logo.jpg" alt="Kreme Tops Bakery logo"
            loading="eager"
            style={{ width:'78%', maxWidth:340, borderRadius:22, border:'1px solid var(--line)', boxShadow:'var(--shadow)', background:'var(--blush)' }} />
          <Img src="/assets/cakes/IMG_0538.jpeg" alt="Kreme Tops cake with roses"
            style={{ position:'absolute', right:0, bottom:-26, width:'46%', borderRadius:18, boxShadow:'var(--shadow)', border:'5px solid var(--cream)', objectFit:'cover', aspectRatio:'1/1' }} />
        </div>
        <div>
          <span style={{ fontFamily:'var(--sans)', fontWeight:700, fontSize:12, letterSpacing:2.6, textTransform:'uppercase', color:'var(--plum)', display:'inline-flex', alignItems:'center', gap:9 }}>
            Our story
          </span>
          <h2 style={{ fontSize:'clamp(2.2rem,4vw,3.2rem)', margin:'14px 0 18px' }}>It always starts with<br />a few words.</h2>
          <p style={{ color:'var(--ink-2)', fontSize:18.5, margin:'0 0 16px', maxWidth:'52ch' }}>Kreme Tops began the way most good things do, with a request too special to say no to. A name, a date, an inside joke that needed icing.</p>
          <p style={{ color:'var(--ink-2)', fontSize:18.5, margin:'0 0 16px', maxWidth:'52ch' }}>Today every cake still starts the same way. You bring the moment; we pipe the rest by hand, in small batches, finished with a bow.</p>
          <div style={{ fontFamily:'var(--serif)', fontStyle:'italic', fontSize:25, color:'var(--plum)', marginTop:8 }}>Made with love, Kreme Tops</div>
        </div>
      </div>
      <style>{`
        @media(max-width:860px){
          .kt-story-grid{grid-template-columns:1fr!important;gap:60px!important;}
          .kt-story-art{max-width:420px;margin:0 auto;}
        }
      `}</style>
    </section>
  );
}
